export default __webpack_public_path__ + "static/media/kemal.e6367a25.svg";